import * as React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

export function AccordionShowcase() {
  const variants = ['single', 'multiple'] as const;
  type AccordionVariant = (typeof variants)[number];

  const [variant, setVariant] = React.useState<AccordionVariant>('single');

  return (
    <div className="space-y-4">
      <StateToggle
        options={variants}
        value={variant}
        onChange={setVariant}
        label="Variant"
        formatLabel={(value) => value.charAt(0).toUpperCase() + value.slice(1)}
      />

      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">
          {variant === 'single' ? 'Single' : 'Multiple'}
        </p>
        {variant === 'single' ? (
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="item-1">
              <AccordionTrigger>What is a design system?</AccordionTrigger>
              <AccordionContent>
                A design system is a collection of reusable components, guided by clear standards,
                that can be assembled to build any number of applications.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-2">
              <AccordionTrigger>Why use tokens?</AccordionTrigger>
              <AccordionContent>
                Tokens store design decisions as data, making it easy to maintain consistency across
                platforms and themes.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-3">
              <AccordionTrigger>How does theming work?</AccordionTrigger>
              <AccordionContent>
                CSS custom properties switch between light and dark palettes, and components
                automatically adapt.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        ) : (
          <Accordion type="multiple" className="w-full">
            <AccordionItem value="a">
              <AccordionTrigger>Can I open many at once?</AccordionTrigger>
              <AccordionContent>
                Yes - set <code className="rounded bg-muted px-1 text-xs">type="multiple"</code>{' '}
                to allow expanding several items simultaneously.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="b">
              <AccordionTrigger>Is it accessible?</AccordionTrigger>
              <AccordionContent>
                Built on Radix UI, it follows WAI-ARIA accordion patterns with full keyboard
                navigation.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        )}
      </div>
    </div>
  );
}
